import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_checkbox-filled",
  "use": "icon_checkbox-filled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_checkbox-filled\"><path d=\"M9 11L12 14L22 4M21 12V19V21H19H5H3.00029L3 19V5L3.00029 3.00002L5 3H16\" stroke=\"black\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol